import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import {
  AuthActions,
  AuthStorageService,
  AuthToken,
  OCC_USER_ID_CURRENT,
  UserIdService,
} from '@spartacus/core';
import { Subscription } from 'rxjs';
import { MultiFactorAuthService } from 'src/app/shared/services/multi-factor-auth.service';

@Component({
    selector: 'app-email-change-token',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './email-change-token.component.html',
    standalone: false
})
export class EmailChangeTokenComponent implements OnInit, OnDestroy {
  queryParams: any;
  token: string | null;
  routeSub: Subscription;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly mfaService: MultiFactorAuthService,
    private readonly router: Router,
    private readonly authStorageService: AuthStorageService,
    private readonly userIdService: UserIdService,
    private readonly store: Store
  ) {}

  ngOnInit() {
    this.routeSub = this.route.queryParams.subscribe((params) => {
      this.authStorageService.setToken({
        access_token: params['bearer'],
        token_type: params['bearer'] ? 'bearer' : '',
      } as AuthToken);
      this.userIdService.setUserId(OCC_USER_ID_CURRENT);
      this.store.dispatch(new AuthActions.Login());
      !!params['token']
        ? this.validateToken(params['token'])
        : console.error('Token is missing');
    });
  }

  validateToken(token: string) {
    this.mfaService.validateToken(token).subscribe(
      (response) => {
        if (response) {
          this.router.navigate(['/my-account/profile']);
          sessionStorage.removeItem('email_request');
        }
      },
      (error) => {
        console.error('Error validating token:', error);
      }
    );
  }
  ngOnDestroy(): void {
    this.routeSub?.unsubscribe();
  }
}
